import { render, staticRenderFns } from "./NumberControl.vue?vue&type=template&id=142dac0a"
import script from "./NumberControl.vue?vue&type=script&lang=ts"
export * from "./NumberControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports